<template>
    <div>
        <h4>
            <span
                v-text="questionType=='1'?'单选':questionType=='2'?'多选':questionType=='3'?'判断':questionType=='4'?'填空':questionType=='5'?'简答':questionType=='6'?'论述':'分析'"
            ></span>
            ：共
            <span>{{questions.length}}</span> 题,
            共
            <span>{{allScore.sum}}</span>分,
        </h4>
        <div v-for="item in questions" :key="item.questionId" :id="item.questionId">
            <div class="preview-topic">
                <div>
                    <p>
                        <span style="font-size:18px" v-text="`${item.questionId}、`"></span>
                        <span
                            v-html="`${item.content.title}(${item.questionPoint}分)`"
                            class="preview-topic-contant"
                        ></span>
                    </p>
                    <!-- 单选 -->
                    <div v-if="questionType ==='1'">
                        <el-radio-group v-model="item.answer" class="questions-list">
                            <ul class="choose-list">
                                <li
                                    v-for="(choice, choiceKey) in item.content.choiceList"
                                    :key="choiceKey"
                                >
                                    <el-radio
                                        :label="choiceKey"
                                        disabled
                                    >{{`${choiceKey}.${choice}`}}</el-radio>
                                </li>
                            </ul>
                        </el-radio-group>
                    </div>
                    <!-- 多选 -->
                    <div v-else-if="questionType === '2'">
                        <el-checkbox-group v-model="item.answer" class="questions-list">
                            <ul class="choose-list">
                                <li
                                    v-for="(answer, answerKey) in item.content.choiceList"
                                    :key="answerKey"
                                >
                                    <el-checkbox
                                        :label="answerKey"
                                        disabled
                                    >{{`${answerKey}.${answer}`}}</el-checkbox>
                                </li>
                            </ul>
                        </el-checkbox-group>
                    </div>
                    <!-- 判断 -->
                    <div v-else-if="questionType === '3'">
                        <el-radio-group v-model="item.answer" class="questions-list">
                            <ul class="choose-list">
                                <li>
                                    <el-radio label="T" disabled>正确</el-radio>
                                </li>
                                <li>
                                    <el-radio label="F" disabled>错误</el-radio>
                                </li>
                            </ul>
                        </el-radio-group>
                    </div>
                    <!-- 填空 -->
                    <div v-else-if="questionType === '4'">
                        <el-tag
                            type="warning"
                            size="small"
                            v-for="(answer, answerIdx) in item.answer"
                            :key="answerIdx"
                            v-html="answer"
                            style="margin-top:10px;"
                        ></el-tag>
                    </div>
                    <!-- 论述分析简答 -->
                    <!-- <div v-else-if="questionType > 4">
                        <el-input
                            type="textarea"
                            v-model="item.answer"
                            disabled
                        ></el-input>
                    </div> -->
                    <div v-else></div>
                    <div class="correct-answer">
                        正确答案是:
                        <span>{{item.answer | ellipsis}}</span>
                    </div>
                    <div class="correct-answer" style="color:#2faed1">系统解析</div>
                    <div v-html="item.analysis"></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            radio: null
        };
    },
    computed: {
        allScore() {
            let sum = 0;
            this.questions.map(item => {
                sum += item.questionPoint;
            });
            let data = { ...this.questions, sum };
            return data;
        }
    },
    filters: {
        ellipsis(value) {
            if (!value) return "";
            if (typeof value === "object") {
                return value.join(",");
            }
            return value;
        }
    },
    props: {
        questionType: {
            type: String
        },
        questions: {
            type: Array,
            default: () => {
                return [];
            }
        }
    },
    methods: {}
};
</script>
<style lang="less">
</style>

